exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screen-monitoring-modal__option{margin-bottom:30px;margin-bottom:1.875rem}.screen-monitoring-modal__description{margin-top:5px;margin-top:.3125rem;font-size:12px;font-size:.75rem;color:#a2a5ae}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f85dfdb","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/screen-monitoring-modal/style.scss
// module id = 253
// module chunks = 0